import { render, staticRenderFns } from "./ContentTemplateList.vue?vue&type=template&id=08d9d83c&"
import script from "./ContentTemplateList.vue?vue&type=script&lang=js&"
export * from "./ContentTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports